<cx-page-slot position="main_content"></cx-page-slot>

<div
  *ngIf="isCartLoading$ | async"
  class="d-flex align-items-center justify-content-center position-fixed top-0 start-0 vh-100 w-100 bg-white z-2000 opacity-75">
  <div class="spinner-border spinner-size" role="status">
    <span class="visually-hidden" data-test-span="spinnerText">Loading...</span>
  </div>
</div>
